import { convertLotacoesToLotacaoEditableTableModel } from 'components/form/editable-table/converter-lotacaoEditableTable'
import { AtividadeColetivaEditarReuniaoQuery, AtividadeColetivaInput } from 'graphql/types.generated'
import { ObservacaoCidadaoModel } from 'view/atividade-coletiva/model-atividadeColetiva'

import { ObservacaoCidadaoEditableTableModel } from '../componentes/observacao-cidadao/ObservacaoCidadaoEditableTable'
import { AtividadeColetivaFormModel } from '../model-atividadeColetiva'
import { sortByNomeCidadao } from '../utils-atividadeColetiva'

const convertObservacaoCidadaoToObservacaoCidadaoEditableTableModel = (
  model: ObservacaoCidadaoModel,
  index: number
): ObservacaoCidadaoEditableTableModel => ({
  _id: index,
  ...model,
})

const convertObservacoesCidadaoToObservacaoCidadaoEditableTableModel = (
  observacoes?: ObservacaoCidadaoModel[]
): ObservacaoCidadaoEditableTableModel[] =>
  observacoes
    ?.slice()
    .sort(sortByNomeCidadao)
    .reverse()
    .map(convertObservacaoCidadaoToObservacaoCidadaoEditableTableModel)

export const convertAtividadeColetivaReuniaoFormModelToInput = (
  model: AtividadeColetivaFormModel
): AtividadeColetivaInput => ({
  id: model.id ?? undefined,
  tipoAtividadeEnum: model.tipoAtividade,
  lotacaoResponsavelId: model.lotacaoResponsavel?.lotacao.id,
  dataAtividade: model.dataAtividade,
  turnoEnum: model.turno,
  numeroParticipantes: model.numeroParticipantes,
  inepLocalAtividadeId: model.localAtividade?.inep?.id,
  unidadeSaudeLocalAtividadeId: model.localAtividade?.unidadeSaudeLocalAtividade?.id,
  outraLocalidade: model.localAtividade?.outraLocalidade,
  atividadeEducacaoPse: false,
  atividadeSaudePse: model.atividadePse?.saude ?? false,
  lotacaoEnvolvidaIds: model.lotacoesEnvolvidas?.map((item) => item.lotacao.id) ?? [],
  temaReuniaoEnums: model.temasReuniao ?? [],
  temaSaudeEnums: model.temasSaude ?? [],
  anotacoes: model.anotacoes,
  observacoes:
    model.observacoes?.map((item) => ({
      cidadaoId: item.cidadao.id,
      observacao: item.observacao,
    })) ?? [],
})

export const convertAtividadeColetivaReuniaoToFormModel = (
  atividadeColetiva: AtividadeColetivaEditarReuniaoQuery['atividadeColetiva']
): AtividadeColetivaFormModel => ({
  id: atividadeColetiva.id,
  registroEnviado: atividadeColetiva.registroEnviado,
  tipoAtividade: atividadeColetiva.tipoAtividade,
  lotacaoResponsavel: { lotacao: atividadeColetiva.lotacaoResponsavel },
  dataAtividade: atividadeColetiva.dataAtividade,
  turno: atividadeColetiva.turno,
  numeroParticipantes: atividadeColetiva.numeroParticipantes,
  atividadePse: {
    educacao: false,
    saude: atividadeColetiva.atividadeSaudePse,
  },
  localAtividade: {
    inep: atividadeColetiva.inepLocalAtividade,
    unidadeSaudeLocalAtividade: atividadeColetiva.unidadeSaudeLocalAtividade,
    outraLocalidade: atividadeColetiva.outraLocalidade,
  },
  lotacoesEnvolvidas: convertLotacoesToLotacaoEditableTableModel(atividadeColetiva.lotacoesEnvolvidas),
  temasReuniao: atividadeColetiva.temasReuniao,
  temasSaude: atividadeColetiva.temasSaude,
  anotacoes: atividadeColetiva.anotacoes,
  observacoes: convertObservacoesCidadaoToObservacaoCidadaoEditableTableModel(atividadeColetiva.observacoes),
})
